import React from 'react';
import { enqueueSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';

import './PopupTechListItem.scss';
import { useDeleteTechnicianModalStore } from '../DeleteTechnicianModal/DeleteTechnicianModalStore';

import { SiteTechnician } from 'api/clients/types';

interface Props {
  siteTechnician: SiteTechnician;
  objectSlug: string;
  refetchObject: () => void;
  canDelete?: boolean;
}

const PopupTechListItem: React.FC<Props> = ({ siteTechnician, objectSlug, canDelete }) => {
  const { open: openDeleteTechnicianModal } = useDeleteTechnicianModalStore();
  const { t } = useTranslation();
  return (
    <>
      <div
        className={`card card-animate border rounded-4 w-100 m-auto mb-2 ${siteTechnician.is_lead ? 'border border-warning' : 'border'}`}
      >
        <div className="card-body">
          <div className="activity-popup-scope">
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center justify-content-between">
                <div
                  className={`avatar-group-item avatar-wrapper ${
                    siteTechnician.is_lead && 'border-warning'
                  } d-flex align-items-center`}
                  key={siteTechnician.technician.id}
                >
                  <img
                    src={siteTechnician.technician.avatar}
                    alt={siteTechnician.technician.last_name ?? 'Technician'}
                    title={`${siteTechnician.technician.last_name} ${siteTechnician.technician.first_name}`}
                    className="rounded-circle avatar-xs"
                  />
                </div>
              </div>

              <div>
                {siteTechnician.technician.last_name
                  ? `${siteTechnician.technician.first_name} ${siteTechnician.technician.last_name}`
                  : siteTechnician.technician.email}
              </div>

              <div>
                <button
                  type="button"
                  className="btn btn-sm btn-ghost-primary btn-icon"
                  onClick={() => {
                    if (!canDelete) {
                      enqueueSnackbar(t('Modals.cannot-delete-tech'), {
                        variant: 'error',
                      });
                      return;
                    }
                    openDeleteTechnicianModal(objectSlug, siteTechnician, true, false);
                  }}
                >
                  <i className="ri-delete-bin-6-fill icon delet-color" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PopupTechListItem;
